const Reports = () => {
  const ReportPost = [
    {
      id: "r01",
      key: "violence_abuse_criminal",
      title: "Violence, abuse, and criminal exploitation",
      list: [
        {
          id: "r002",
          key: "exploitation_and_abuse",
          title: "Exploitation and abuse of people under 18",
          report: {
            id: "r002",
            parent_title: "Exploitation and abuse of people under 18",
            sub: "We don't allow the following",
            list_des: [
              "Showing or promotion sexual exploitation of people under 18, including child sexual abuse material (CSAM),grooming, solicitaion, and pedophilia",
              "Showing or promoting physical abuse neglect, endangerment, and psyschological abuse of people under 18",
              "Showing or promoting trafficking of people under 18 and recruitment of child soldiers",
              "Promoting or facilitating underage marriage",
            ],
          },
        },
        {
          id: "r003",
          key: "pysical_and_violent",
          title: "Physical violence and violent threats",
          report: {
            id: "r003",
            parent_title: "Physical violence and violent threats",
            sub: "We don't allow the following",
            list_des: [
              "Showing, promoting, or threatening physical violence, including real-word torture,graphic violence,and extreme pysical fighting",
              "Promoting or materially supporting violent or hateful organizations,indcluding violent extremists and criminal organizations",
            ],
          },
        },
        {
          id: "r004",
          key: "sexual_and_abuse",
          title: "Sexual exploitation and abuse",
          report: {
            id: "r004",
            parent_title: "Sexual exploitation and abuse",
            sub: "We don't allow the following",
            list_des: [
              "Showing, promoting, or threatening physical violence, including real-word torture,graphic violence,and extreme pysical fighting",
              "Promoting or materially supporting violent or hateful organizations,indcluding violent extremists and criminal organizations",
            ],
          },
        },
        {
          id: "r005",
          key: "human_exploitation",
          title: "Human exploitation",
          report: {
            id: "r005",
            parent_title: "Human exploitation",
            sub: "We don't allow the following",
            list_des: [
              "Showing, promoting, or threatening physical violence, including real-word torture,graphic violence,and extreme pysical fighting",
              "Promoting or materially supporting violent or hateful organizations,indcluding violent extremists and criminal organizations",
            ],
          },
        },
        {
          id: "r006",
          key: "animal_abuse",
          title: "Animal abuse",
          report: {
            id: "r006",
            parent_title: "Animal abuse",
            sub: "We don't allow the following",
            list_des: [
              "Showing, promoting, or threatening physical violence, including real-word torture,graphic violence,and extreme pysical fighting",
              "Promoting or materially supporting violent or hateful organizations,indcluding violent extremists and criminal organizations",
            ],
          },
        },
        {
          id: "r007",
          key: "other_criminal_activities",
          title: "Other criminal activities",
          report: {
            parent_title: "Other criminal activities",
            sub: "We don't allow the following",
            list_des: [
              "Showing, promoting, or threatening physical violence, including real-word torture,graphic violence,and extreme pysical fighting",
              "Promoting or materially supporting violent or hateful organizations,indcluding violent extremists and criminal organizations",
            ],
          },
        },
      ],
    },
    {
      id: "r02",
      key: "hate_and_harassment",
      title: "Hate and harassment",
      list: [
        {
          id: "r008",
          title: "Hate speech and hatefull behaviors",
          report: {
            id: "r008",
            parent_title: "Hate speech and hatefull behaviors",
            sub: "We don't allow the following",
            list_des: [
              "Showing or promoting violence, discrimination, and other harms, including charaterstics, such as race, religion, gender, and sexual orientation",
              "Demeaning someone on the basis of these personal charaterstics, including using hateful slurs",
              "Denying well-documented historical events that harmed protected grouops, such as the holocaust",
              "Promoting or supporting items, individuals, and organizations that promote hateful ideologies",
            ],
          },
        },
        {
          id: "r009",
          key: "pysical_and_violent",
          title: "Harassment and bullying",
          report: {
            id: "r009",
            parent_title: "Harassment and bullying",
            sub: "We don't allow the following",
            list_des: [
              "Showing or promoting insulting someone or threatening to insult someone, including using profanity or obscene language to degrade them",
              "Showing, promoting, or threatening harassment or bullying, physical or otherwise, of other - including coordinated harassment",
              "Showing, promoting, or threatening behaviors such as doxing, blackmailing, revealing, or calling for the reveal of private or sensitive information",
            ],
          },
        },
      ],
    },
    {
      id: "r03",
      key: "suicide_and_self_harm",
      title: "Suicide and self-harm",
      report: {
        hasParent: "",
        id: "r03",
        parent_title: "Suicide and self-harm",
        sub: "We don't allow the following",
        list_des: [
          "Showing, promoting, or providing instructions on suicide, self-harm, and related games, dares, challenges, hoaxes, and pacts",
          "Sharing plans for suicide and self-harm",
        ],
      },
    },
    {
      id: "r04",
      key: "disordered_and_unhealthy",
      title: "Disordered eating and unhealthy body image",
      report: {
        hasParent: "",
        id: "r04",
        parent_title: "Disordered eating and unhealthy body image",
        sub: "We don't allow the following",
        list_des: [
          "Shwoing or promotiong disordered eating, such as extreme dieting, fasting, bengeing, and intentional vomiting, as well as other dangerous weight loss behaviors, including compulsive exercies and use of potentially harmful medications and supplements",
          "Showing or promoting unhealthy body measurement trends",
        ],
      },
    },
    {
      id: "r05",
      key: "dangerous_challenges",
      title: "Dangerous activities and challenges",
      report: {
        hasParent: "",
        id: "r05",
        parent_title: "Dangerous activities and challenges",
        sub: "We don't allow the following",
        list_des: [
          "Showing, promoting, or providing instructions on suicide, self-harm, and related games, dares, challenges, hoaxes, and pacts",
          "Sharing plans for suicide and self-harm",
        ],
      },
    },
    {
      id: "r06",
      key: "nudity_and_sexual",
      title: "Nudity and sexual content",
      list: [
        {
          id: "r0032",
          title: "Youth sexual activity, solicitation, and exploitation",
          report: {
            id: "r0032",
            parent_title: "Youth sexual activity, solicitation, and exploitation",
            sub: "We don't allow the following",
            list_des: [
              "Showing or promoting child sexual abuse material (CSAM) or youth sexual activity",
              "Showing or promoting youth nudity",
              "Promoting or normalizing youth sexual exploitation, sexual abuse and sexual fetishism, including grooming, sextortion, and pedophilia",
              "Showing or promoting sexual solicitation, incuding inviting people under 18 to engage in a sexual act, go off-platform, and share sexually explicit images, even if the initiatoris also under 18",
              "Objectifyingor sexualizing people under 18 through images or in-app interaction features",
            ],
          },
        },
        {
          id: "r0033",
          title: "Adult sexual acitvity, services, and solictation",
          report: {
            id: "r0033",
            parent_title: "Adult sexual acitvity, services, and solictation",
            sub: "We don't allow the following",
            list_des: [
              "Offering or asking for sexual partners or engaging in sexual act",
              "Sexually explicit content, including pornographic content showing sexual intercourse, masturbation, and vivid description of sexual acts",
            ],
          },
        },
        {
          id: "r0034",
          title: "Adult nudity",
          report: {
            id: "r0034",
            parent_title: "Adult nudity",
            sub: "We don't allow the following",
            list_des: [
              "Adult nudity, including in photography and digitally created images (such as manga and anime)",
              "Some non-sexualized content showing areolas or nipples in medical contexts, for educational purposes, as part of a culturally accepted pratice, or in culturally expected contexts, such as showing areolas or nipples during breastfeeding or at celebration festivals (like a carnival), is allowed.",
            ],
          },
        },
        {
          id: "r0035",
          title: "Sexually explicit language",
          report: {
            id: "r0035",
            parent_title: "Sexually explicit language",
            sub: "We don't allow the following",
            list_des: ["Sexually explicit narratives, such as vivid descriptions of sexual acts by adults or people under 18"],
          },
        },
      ],
    },
    {
      id: "r07",
      key: "shocking_and_graphic",
      title: "Shocking and graphic content",
      report: {
        hasParent: "",
        id: "r07",
        parent_title: "Shocking and graphic content",
        sub: "We don't allow the following",
        list_des: [
          "Graphic deaths and accidents",
          "Human or animal body parts that are dismembered, mutilated, charred, burned, or severly injured",
          "Some content shown in an educational, artistic, or professional setting, such as professional fighting, is allowed.",
        ],
      },
    },
    {
      id: "r08",
      key: "misinformation",
      title: "Misinformation",
      list: [
        {
          id: "r0044",
          title: "Election misinformation",
          report: {
            id: "r0044",
            parent_title: "Election misinformation",
            sub: "We don't allow the following",
            list_des: ["Misinformation on how to vote or run for office", "Misinformation on final election results or outcomes"],
          },
        },
        {
          id: "r0045",
          title: "",
          report: {
            id: "r0045",
            parent_title: "Harmful misinformation",
            sub: "We don't allow the following",
            list_des: [
              "Misniformation that poses a risk to public safety or may cause panic, such as using old footage of a past event and falely presenting it as current, or spreading inaccurate claims that essential items like food or water are no longer availble",
              "Medical misinformation that poses a risk to public hearth, such as misleading statements about vaccines, and inaccurate medical advice that discourages people from getting appropriate medical care",
              "Climate change misinformation that contradicts well-established scientific consensus, such as denying the existence of climate change",
              "Dangerous conspiracy theories that promote violence, hatred, or target individuals, such as those causing prejudice toward a specific group and cause harm",
            ],
          },
        },
        {
          id: "r0046",
          title: "Deepfakes, synthetic media, and manipulated media",
          report: {
            id: "r0046",
            parent_title: "Deepfakes, synthetic media, and manipulated media",
            sub: "We don't allow the following",
            list_des: [
              "Synthetic or manipulated media showing realistic scenes that are not prominently disclosed or labeled in th video",
              "Synthetic media that  containts the likeness (visual or aduio) of a real person when used for political or commerical endorsements, or if violative of our community guidelines",
              "Material that has been edited in a way that may mislead a person about real-world events",
              "Synthetic media showing a public figure in artistic and educational contexts, such as a celebrity doing a popular dance, and a historical figure featured in a history lesson, is allowed.",
            ],
          },
        },
      ],
    },
    {
      id: "r09",
      key: "deceptive_and_spam",
      title: "Deceptive behavior and spam",
      list: [
        {
          id: "r0050",
          title: "Fake engagement",
          report: {
            id: "r0050",
            parent_title: "Fake engagement",
            sub: "We don't allow the following",
            list_des: ["Providing instructions or promoting methods or services to help a use artificially increase engagement, such as selling followers or likes"],
          },
        },
        {
          id: "r0051",
          title: "Spam",
          report: {
            id: "r0051",
            parent_title: "Spam",
            sub: "We don't allow the following",
            list_des: [
              "Accounts that are operated in bulk or through unauthorized automation such as bots to distribute high-volume content, including for commerical purposes",
              "Networks of accounts that represent similar enities or post similar content to lead users to specific locations on FlipFlop or off-platform, such as other accounts, websites, and businesses",
            ],
          },
        },
        {
          id: "r0052",
          key: "sexual_and_abuse",
          title: "Sexual exploitation and abuse",
          report: {
            parent_title: "Sexual exploitation and abuse",
            sub: "We don't allow the following",
            list_des: [
              "Showing, promoting, or threatening physical violence, including real-word torture,graphic violence,and extreme pysical fighting",
              "Promoting or materially supporting violent or hateful organizations,indcluding violent extremists and criminal organizations",
            ],
          },
        },
        {
          id: "r0053",
          title: "Undisclosed branded content",
          report: {
            id: "r0053",
            parent_title: "Undisclosed branded content",
            sub: "We don't allow the following",
            list_des: [
              "User are reuqired to clearly disclose their Branded Content. Branded content on FilpFlop is difined as content that promotes goods or services where the creator will recieve (or have already recieved) something of value from a third parth, such as a brand, in exchange for creator's post, or which creator might otherwise need to disclose in accordance with the local laws or regulations. it could be a brand endorsement, partnership, or another kind of promotion for a product or service. Branded Content should follow our Branded Content Policy.",
            ],
          },
        },
      ],
    },
    {
      id: "r010",
      key: "regulated_and_activity",
      title: "Regulated goods and avtivities",
      list: [
        {
          id: "r0056",
          title: "Gambling",
          report: {
            id: "r0056",
            parent_title: "Gambling",
            sub: "We don't allow the following",
            list_des: ["Gambling services, such as casinos, poker, slot games, roulette, lotteries, betting tips, and gambling-related software and apps"],
          },
        },
        {
          id: "r0057",
          title: "Alcohol, tobacco, and drugs",
          report: {
            id: "r0057",
            parent_title: "Alcohol, tobacco, and drugs",
            sub: "We don't allow the following",
            list_des: [
              "Showing young people possessing, consuming, or trading alcohol, tobacco, products, drugs, or other regulated substances",
              "Showing or promoting adults consuming drugs or other regulated substatnces for recreational purposes",
              "Showing or promoting the misuse of common household items or over-the-counter products to get intoxicated, such as antihistamines and sniffing glue",
              "Providing instructions on how to make homemade spirits, drugs, or other regulated substatnces",
              "Facilitating the trade or purchase of alcohol, tobacco products, drugs, or other regulated substances",
            ],
          },
        },
        {
          id: "r0058",
          title: "Firearms and dangerous weapons",
          report: {
            id: "r0058",
            parent_title: "Firearms and dangerous weapons",
            sub: "We don't allow the following",
            list_des: [
              "Showing or promoting firearms or explosive weapons that are not use in a safe or appropriate setting",
              "Facilitating the trade of or offering instructions on how to make firearms or explosive weapons",
            ],
          },
        },
        {
          id: "r0059",
          title: "Trade of other regulated goods and services",
          report: {
            id: "r0059",
            parent_title: "Trade of other regulated goods and services",
            sub: "We don't allow the following",
            list_des: [
              "Trading fake currency and documents and stolen information",
              "Trading wildlife animals and any part of an endangered animal, such as products and medicince made from elephant ivory",
            ],
          },
        },
      ],
    },
    {
      id: "r011",
      key: "fraud_and_scams",
      title: "Frauds and scams",
      report: {
        id: "r011",
        parent_title: "Frauds and scams",
        sub: "We don't allow the following",
        list_des: [
          "Financial, investment, employment, or phishing scam, including indentity theft",
          "Coordination or facilitation of scams, or instruction on how to carry out scams",
          "Organizational fraud, such as money laundering and moving illegally acquired money for someone else (money muling)",
          "recruitment for multi-level marketing (MLM)",
        ],
      },
    },
    {
      id: "r012",
      key: "sharing_personal_info",
      title: "Sharing personal information",
      report: {
        id: "r012",
        parent_title: "Sharing personal information",
        sub: "We don't allow the following",
        list_des: [
          "Sharing personal phone numbers and home addresses",
          "Sharing financial and payment information, such as bank accounts and credit card numbers",
          "Sharing login information, such as username and passwords",
          "Sharing identity documentation or numbers, such as passports and social security numbers",
        ],
      },
    },
    {
      id: "r013",
      key: "adult_sexual_activity",
      title: "Adult sexual acitvity, services, an solictation",
      report: {
        id: "r013",
        parent_title: " Offering or asking for sexual partners or engaging in sexual act",
        sub: "We don't allow the following",
        list_des: ["Sexually explicit content, including pornographic content showing sexual intercourse, masturbation, and vivid description of sexual acts Percentage Submit"],
      },
    },
    {
      id: "r014",
      key: "other",
      title: "Other",
      report: {
        id: "r014",
        parent_title: "Other",
        sub: "We don't allow the following",
        list_des: [
          "Our priority is to provide a safe and supportive enviroments. We also encourage authentic interactions by keeping deceptive content and accounts off our platform. Select this if your reason for reporting does not fall under any of the listed categories.",
        ],
      },
    },
  ];

  return { ReportPost };
};
export default Reports;
